import { computed } from 'vue'
import store from '@/store'
import { isMobile } from '@/utils'
import VERIFY from './verify-hk.png'
import GOODS from './goods-hk.png'
import MILESTONE from './milestone-hk.png'
import RULE from './rule-hk.png'
import MOBILE_VERIFY from '../mobile/sectionTitles/verify-hk.png'
import MOBILE_GOODS from '../mobile/sectionTitles/goods-hk.png'
import MOBILE_MILESTONE from '../mobile/milestone/title-hk.png'
import MOBILE_RULE from '../mobile/rule/title-hk.png'

// 繁中 PART 01 / 02 使用各端设计稿组合，其他语言仍复用单独艺术字。
const useDesignTitle = computed(() => ['hk', 'tw'].includes(store.state.locale))

export const verifyTitle = computed(() => useDesignTitle.value ? (isMobile ? MOBILE_VERIFY : VERIFY) : undefined)
export const goodsTitle = computed(() => useDesignTitle.value ? (isMobile ? MOBILE_GOODS : GOODS) : undefined)
export const milestoneTitle = computed(() => useDesignTitle.value ? (isMobile ? MOBILE_MILESTONE : MILESTONE) : undefined)
export const ruleTitle = computed(() => useDesignTitle.value ? (isMobile ? MOBILE_RULE : RULE) : undefined)
